import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { ParliamentChart } from './parliamentChart'
import { ParliamentTable } from './parliamentTable'
import './style.scss'
import { Header } from 'components/header'

export default function index(): ReactElement {
  const [data, setData] = useState(null)

  useEffect(() => {
    fetch(
      'https://wch-interactive.storage.googleapis.com/legislatives-france-2022/seats-round-2.json'
    ).then(res =>
      res.json().then(data => {
        setData(data)
      })
    )
  }, [])

  return (
    <>
      {data && (
        <>
          <Header
            title={data.meta.title}
            description={data.meta.lead}
            doneMunicipalCouncil={data.meta.doneMunicipalCouncil}
            countStatus={data.meta.countStatus}
          />
          <ParliamentChart
            seatColorArray={data.seatsPerParty
              .sort((a, b) => a.orderFromLeftToRight - b.orderFromLeftToRight)
              .map(row => {
                return { seats: row.seats, color: row.color }
              })}
          />
          <ParliamentTable seatsPerParty={data.seatsPerParty} />
        </>
      )}
    </>
  )
}
